/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { addslashes, array_unique, htmlspecialchars } from './util.js';
import { postToBackend } from './fetch-util.js';
import { mjt } from './i18ntexts.js';

import { MPlugins } from './plugins.js';

import { MVMediaMetadata } from './media-data-view.js';

/**
 * add backlinks & "show all" link to "ref_media" meta data fields
 */
export function register_ref_media_meta_field_plugin( meta_id ) {
	const plugin_name = 'std-view-ref-media-'+meta_id;
	if( MPlugins.isRegistered(plugin_name) ) return;

	MPlugins.register( [], plugin_name, {
		type: 'MediaMetaViewData',
		meta_ids: [ meta_id ],

		setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo, context ) {
			let val_html_link_arr = [];
			if( val_arr && val_arr.length ) {
				for( const val of val_arr ) {
					const link_to_class = 'link-to-media-id-'+val;
					const link_to_info_title = mjt('link-to-info','!').replace('%1',val).replace('%2',media_id);
					const link_to_html = mjt('link-to').replace('%1',val);
					// const all_links_to_info_title = mjt('all-links-to-info','!').replace('%1',val).replace('%2',media_id);
					// const all_links_to_class = 'all-links-to-media-id-'+val;
					val_html_link_arr.push(
						'<div class="link-block">'
						+ '<span class="link link-to '+link_to_class+'"'
						+    ' onclick="MVMediaPage.start_search(\''+htmlspecialchars(addslashes(val),true,true)+'\',3)"'
						+    ' title="'+htmlspecialchars(link_to_info_title,true,true)+'">'
						+   link_to_html
						+ '</span>'
						// + ' | '
						// + '<span class="link all-links-to '+all_links_to_class+'"'
						// +    ' onclick="MVMediaPage.start_search(\''+htmlspecialchars(addslashes(val),true,true)+'\','+meta_id+')"'
						// +    ' title="'+htmlspecialchars(all_links_to_info_title,true,true)+'">'
						// +   (mjt('all-links-to').replace('%1',val))
						// + '</span>'
						+'</div>'
					);
				}
			}
			val_html = val_html_link_arr.join('');

			const td = tr.children('td');
			let dh = td.children('.data-holder').empty();
			if( dh.length ) {
				dh.html(val_html);
			} else {
				dh = MVMediaMetadata.wrapWithMetaDataHolder(meta_id,val_html);
				td.html(dh);
			}

			const addMetaLinkLink = function( dh, lnks_arr, loca_title ) {
				dh.append(
					'<div class="link-block">'
					+ '<span class="emph-link different"'
					+    ' onclick="MVMediaPage.start_search('+htmlspecialchars(JSON.stringify(lnks_arr),true,true)+',3)"'
					+    ' title="'+lnks_arr.join(', ')+'">'
					+   loca_title+' ('+lnks_arr.length+')'
					+ '</span>'
					+'</div>'
				);
			};


			const lnks_outbound = val_arr && val_arr.length ? array_unique(val_arr.slice()) : [];
			if( lnks_outbound.length > 0 ) {
				addMetaLinkLink(dh,lnks_outbound,mjt('links-show-all-outbound'));
			}


			const postdata = 'media_id='+encodeURIComponent(media_id)
							+ '&meta_id='+meta_id
							+ '&outbound_links='+encodeURIComponent(lnks_outbound.join(','));
			postToBackend('json/media/meta-transitivelinks', postdata, function(j) {
				let lnks_inbound = [];
				let lnks_transitive = [];

				if( j && !j.error ) {
					if( j.inbound && j.inbound.length ) {
						// inbound links
						lnks_inbound = j.inbound.slice();

						let html_link_arr = [];
						for( const val of j.inbound ) {
							const links_to_class = 'links-to-media-id-'+val;
							const links_to_info_title = mjt('links-to-info','!').replace('%1',val).replace('%2',media_id);
							const links_to_html = mjt('links-to').replace('%1',val);
							html_link_arr.push(
								'<div class="link-block">'
								+ '<span class="link links-to '+links_to_class+'"'
								+    ' onclick="MVMediaPage.start_search(\''+htmlspecialchars(addslashes(val),true,true)+'\',3)"'
								+    ' title="'+htmlspecialchars(links_to_info_title,true,true)+'">'
								+   links_to_html
								+ '</span>'
								+'</div>'
							);
						}
						dh.append(
							'<span class="xinfo">'
							+   html_link_arr.join('')
							+'</span>'
						);
					}

					if( j.transitive && j.transitive.length ) {
						// transitive links
						lnks_transitive = j.transitive.slice();
					}

					if( j.media_meta ) {
						for( const [media_id,meta] of Object.entries(j.media_meta) ) {
							const link_to_class = 'link-to-media-id-'+media_id;
							const links_to_class = 'links-to-media-id-'+media_id;
							const $linkSpans = dh.find('.'+link_to_class+',.'+links_to_class);
							if( $linkSpans.length ) {
								const metaTitleArr = meta[1]??[];
								const metaTitleStr = metaTitleArr[0]??'';
								if( metaTitleStr ) {
									const link_to_html = mjt('link-to-with-title').replace('%1',media_id).replace('%2',htmlspecialchars(metaTitleStr));
									$linkSpans.html(link_to_html);
								}
							}
						}
					}
				}

				tr.removeClass('md-hide').addClass('md-avl');

				if( lnks_inbound.length > 0 ) {
					addMetaLinkLink(dh,lnks_inbound,mjt('links-show-all-inbound'));
				}
				if( lnks_outbound.length > 0 && lnks_inbound.length > 0 ) {
					const lnks_all = array_unique( lnks_outbound.concat(lnks_inbound) );
					addMetaLinkLink(dh,lnks_all,mjt('links-show-all-all'));
				}
				if( lnks_transitive.length > 1 ) {
					addMetaLinkLink(dh,lnks_transitive,mjt('links-show-transitive'));
				}
			} );
		},

	} );
}

